
import React,{useCallback} from 'react'
import PropTypes from 'prop-types'
import {withRouter} from 'react-router-dom'
import {useSelector} from 'react-redux'

//import utility functions
import {
  getCID,
  getDataFromURL,
  getCurrentStep
} from '../../../utilities/function/urlparams'

import Loading from '../../shared/loading'
import PageSlider from '../../shared/pageslider'
import Breadcrumbs from '../../shared/breadcrumbs'
import SelectBillingCycle from '../../shared/steps/selectbillingcycle'
import SelectAdditionalOptions from '../../shared/steps/selectadditionaloptions'
import CloseButton from '../../shared/closebutton'
import ProductSidebar from '../../shared/sidebar/productsidebar'
import SelectConfigOptions from '../../shared/steps/selectconfigoptions'
import {usePageCallback} from "../../../utilities/function/page";

let VPS = (props) =>{
  const {location} = props
  const {configurations,cartStatus} = useSelector(state=>({
    configurations : state.app.configurations,
    cartStatus: state.app.cartStatus
  }))
  const cid = getCID(getDataFromURL(location.search))
  const step = getCurrentStep(configurations,cid)
  const {setBillingCycle,getAdditionalOptionsData,setAddons} = usePageCallback(cid)
  const getBreadcrumbsData = useCallback(() => {
    const list = [{
      label: 'Billing Cycle',
      itemStep: 0,
      configKey: 'billing_cycle_id'
    },{
      label: 'Resources',
      itemStep: 1,
      configKey: 'config'
    }]
    const addonData = getAdditionalOptionsData()
    if(addonData && addonData.length > 0){
      list.push({
        label: 'Addons',
        itemStep: 2,
        configKey: 'addons'
      })
    }
    return list
  },[getAdditionalOptionsData])
  if(cartStatus==='loading'){
    return (
      <div className='of-page'>
        <Loading wrapper={true}/>
      </div>
    )
  }
  return (
    <div className={`of-vps clearfix of-page`}>
      <div className={'of-page__wrapper'}>
        <PageSlider step={step}>
          <Breadcrumbs data={getBreadcrumbsData()} step={step} cid={cid} />
          <SelectBillingCycle showOn={0} callback={setBillingCycle} cid={cid} />
          <SelectConfigOptions />
          <SelectAdditionalOptions showOn={2} data={getAdditionalOptionsData()} callback={setAddons} cid={cid} />
          <CloseButton />
        </PageSlider>
        <ProductSidebar />
      </div>
    </div>
  )
}

VPS = withRouter(VPS)

VPS.propTypes = {
  location: PropTypes.object
}

export default VPS